import classNames from "classnames";
import React from "react";

type NativeTextareaProps = JSX.IntrinsicElements["textarea"];

interface Props extends NativeTextareaProps {}

const Textarea = (props: Props) => {
  return <textarea {...props} className={classNames("Textarea", props.className)} />;
};

export default Textarea;
